import { Controller } from '@hotwired/stimulus'
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';

export default class extends Controller {
  static targets = ['datepickerSingleSelect']

  connect() {
    return new AirDatepicker(this.datepickerSingleSelectTarget, {
      locale: localeEn,
      format: 'MM/DD/YYYY',
      buttons: ['clear'],
      autoClose: true,
      selectedDates: [new Date(this.element.value).toUTCString()],
      onSelect: () => {
        if (this.datepickerSingleSelectTarget.dataset.submitForm === 'true') {
          this.datepickerSingleSelectTarget.form.submit();
        }
      }
    });
  }
}
